import { v7 as uuidv7 } from 'uuid'
import { DRIVEPOINTS_BACKEND_URL, X_DP_MODE } from './valhalla.js'

/**
 * Build headers for Drivepoints backend requests (Stripe-like behavior).
 * - X-Correlation-Id: UUID v7 (client-generated); if not provided server generates and validates.
 * - Idempotency-Key: UUID v7 for POST/PUT when X-DP-mode: test (required by server in test mode).
 * @param {Object} options
 * @param {string} [options.correlationId] - Optional; if omitted a new UUID v7 is generated per request
 * @param {string} [options.idempotencyKey] - Required for POST/PUT in test mode; one per logical operation
 * @param {boolean} [options.requireIdempotency = false] - True when X-DP-mode is test and method is POST/PUT
 * @returns {Record<string, string>} Headers to merge into request config
 */
export function drivepointsRequestHeaders({
  correlationId,
  idempotencyKey,
  requireIdempotency = false,
} = {}) {
  // const isTestMode = X_DP_MODE && X_DP_MODE.toLowerCase() === 'test'
  if (
    DRIVEPOINTS_BACKEND_URL.includes('drivepoints.com') ||
    DRIVEPOINTS_BACKEND_URL.includes('localhost')
  ) {
    const headers = {
      'X-Correlation-Id': correlationId ?? uuidv7(),
    }
    if (requireIdempotency) {
      headers['Idempotency-Key'] = idempotencyKey ?? uuidv7()
    }

    if (X_DP_MODE) {
      headers['X-DP-mode'] = X_DP_MODE
    }

    return headers
  }
  // if not drivepoints backend, don't add any headers
  return {}
}

/**
 * Generate a new UUID v7 (time-ordered) for correlation or idempotency.
 * @returns {string}
 */
export function generateUuidV7() {
  return uuidv7()
}
